// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Chesnovskaya <anastasia.chesnovskaya@celadon.ae>

import GlobalStyles from '../../../../../../config/styles';

const styles = theme => ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    zIndex: 10,
    padding: '30px 0px',
  },
  text: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_TITLE,
    color: GlobalStyles.color.COLOR_REJECT,
    textAlign: 'center',
    width: '60%',
    [theme.breakpoints.down(700)]: {
      width: '90%',
    },
    [theme.breakpoints.down(500)]: {
      width: '100%',
    },
  },
  email: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_TITLE,
    color: GlobalStyles.color.COLOR_GREY,
    marginTop: 16,
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.5
    }
  }
});

export default styles;
